import * as Constants from '../../constants';
import {
  PropertySchema,
  ResourceSchema,
  RootNodeSchema
} from '../../types/SchemaExplorer';
import { SchemaTreeNode } from '../../types/Tree';
import {
  AddChildNode,
  AddChildNodeFailed,
  AddChildNodeSuccess,
  AddPropertySchema,
  AddPropertySchemaFailed,
  AddPropertySchemaSuccess,
  AddRootNode,
  AddRootNodeFailed,
  AddRootNodeSuccess,
  CollapseNode,
  DeleteChildNode,
  DeleteChildNodeFailed,
  DeleteChildNodeSuccess,
  DeleteRootNode,
  DeleteRootNodeFailed,
  DeleteRootNodeSuccess,
  EditChildNode,
  EditChildNodeFailed,
  EditChildNodeSuccess,
  EditPropertySchema,
  EditPropertySchemaFailed,
  EditPropertySchemaSuccess,
  EditRootNode,
  EditRootNodeFailed,
  EditRootNodeSuccess,
  GetChildNodes,
  GetChildNodesFailed,
  GetChildNodesSuccess,
  GetNodeProperties,
  GetNodePropertiesFailed,
  GetNodePropertiesSuccess,
  GetRootNodes,
  GetRootNodesFailed,
  GetRootNodesSuccess,
  SelectNode
} from './ActionTypes';

export const getRootNodes = (): GetRootNodes => ({
  type: Constants.GET_ROOT_NODES_SCHEMA
});

export const getRootNodesSuccess = (
  rootNodes: RootNodeSchema[]
): GetRootNodesSuccess => ({
  type: Constants.GET_ROOT_NODES_SCHEMA_SUCCESS,
  payload: { rootNodes }
});

export const getRootNodesFailed = (): GetRootNodesFailed => ({
  type: Constants.GET_ROOT_NODES_SCHEMA_FAILED
});

export const getChildNodes = (vmid: string): GetChildNodes => ({
  type: Constants.GET_CHILD_NODES_SCHEMA,
  payload: { vmid }
});

export const getChildNodesSuccess = (
  parentVmid: string,
  childNodes: ResourceSchema[]
): GetChildNodesSuccess => ({
  type: Constants.GET_CHILD_NODES_SCHEMA_SUCCESS,
  payload: { parentVmid, childNodes }
});

export const getChildNodesFailed = (): GetChildNodesFailed => ({
  type: Constants.GET_CHILD_NODES_SCHEMA_FAILED
});

export const collapseNode = (vmid: string): CollapseNode => ({
  type: Constants.COLLAPSE_SCHEMA_NODE,
  payload: { vmid }
});

export const selectNode = (node: SchemaTreeNode): SelectNode => ({
  type: Constants.SELECT_SCHEMA_NODE,
  payload: { node }
});

export const addRootNode = (rootNode: RootNodeSchema): AddRootNode => ({
  type: Constants.ADD_ROOT_NODE_SCHEMA,
  payload: { rootNode }
});

export const addRootNodeSuccess = (
  rootNode: RootNodeSchema
): AddRootNodeSuccess => ({
  type: Constants.ADD_ROOT_NODE_SCHEMA_SUCCESS,
  payload: { rootNode }
});

export const addRootNodeFailed = (): AddRootNodeFailed => ({
  type: Constants.ADD_ROOT_NODE_SCHEMA_FAILED
});

export const editRootNode = (rootNode: RootNodeSchema): EditRootNode => ({
  type: Constants.EDIT_ROOT_NODE_SCHEMA,
  payload: { rootNode }
});

export const editRootNodeSuccess = (
  rootNode: RootNodeSchema
): EditRootNodeSuccess => ({
  type: Constants.EDIT_ROOT_NODE_SCHEMA_SUCCESS,
  payload: { rootNode }
});

export const editRootNodeFailed = (): EditRootNodeFailed => ({
  type: Constants.EDIT_ROOT_NODE_SCHEMA_FAILED
});

export const deleteRootNode = (vmid: string): DeleteRootNode => ({
  type: Constants.DELETE_ROOT_NODE_SCHEMA,
  payload: { vmid }
});

export const deleteRootNodeSuccess = (vmid: string): DeleteRootNodeSuccess => ({
  type: Constants.DELETE_ROOT_NODE_SCHEMA_SUCCESS,
  payload: { vmid }
});

export const deleteRootNodeFailed = (): DeleteRootNodeFailed => ({
  type: Constants.DELETE_ROOT_NODE_SCHEMA_FAILED
});

export const addChildNode = (childNode: ResourceSchema): AddChildNode => ({
  type: Constants.ADD_CHILD_NODE_SCHEMA,
  payload: { childNode }
});

export const addChildNodeSuccess = (
  childNode: ResourceSchema
): AddChildNodeSuccess => ({
  type: Constants.ADD_CHILD_NODE_SCHEMA_SUCCESS,
  payload: { childNode }
});

export const addChildNodeFailed = (): AddChildNodeFailed => ({
  type: Constants.ADD_CHILD_NODE_SCHEMA_FAILED
});

export const editChildNode = (childNode: ResourceSchema): EditChildNode => ({
  type: Constants.EDIT_CHILD_NODE_SCHEMA,
  payload: { childNode }
});

export const editChildNodeSuccess = (
  childNode: ResourceSchema
): EditChildNodeSuccess => ({
  type: Constants.EDIT_CHILD_NODE_SCHEMA_SUCCESS,
  payload: { childNode }
});

export const editChildNodeFailed = (): EditChildNodeFailed => ({
  type: Constants.EDIT_CHILD_NODE_SCHEMA_FAILED
});

export const deleteChildNode = (vmid: string): DeleteChildNode => ({
  type: Constants.DELETE_CHILD_NODE_SCHEMA,
  payload: { vmid }
});

export const deleteChildNodeSuccess = (
  vmid: string
): DeleteChildNodeSuccess => ({
  type: Constants.DELETE_CHILD_NODE_SCHEMA_SUCCESS,
  payload: { vmid }
});

export const deleteChildNodeFailed = (): DeleteChildNodeFailed => ({
  type: Constants.DELETE_CHILD_NODE_SCHEMA_FAILED
});

export const getNodeProperties = (vmid: string): GetNodeProperties => ({
  type: Constants.GET_SCHEMA_NODE_PROPERTIES,
  payload: { vmid }
});

export const getNodePropertiesSuccess = (
  properties: PropertySchema[]
): GetNodePropertiesSuccess => ({
  type: Constants.GET_SCHEMA_NODE_PROPERTIES_SUCCESS,
  payload: { properties }
});

export const getNodePropertiesFailed = (): GetNodePropertiesFailed => ({
  type: Constants.GET_SCHEMA_NODE_PROPERTIES_FAILED
});

export const addPropertySchema = (
  property: PropertySchema
): AddPropertySchema => ({
  type: Constants.ADD_PROPERTY_SCHEMA,
  payload: { property }
});

export const addPropertySchemaSuccess = (
  property: PropertySchema
): AddPropertySchemaSuccess => ({
  type: Constants.ADD_PROPERTY_SCHEMA_SUCCESS,
  payload: { property }
});

export const addPropertySchemaFailed = (): AddPropertySchemaFailed => ({
  type: Constants.ADD_PROPERTY_SCHEMA_FAILED
});

export const editPropertySchema = (
  property: PropertySchema
): EditPropertySchema => ({
  type: Constants.EDIT_PROPERTY_SCHEMA,
  payload: { property }
});

export const editPropertySchemaSuccess = (
  property: PropertySchema
): EditPropertySchemaSuccess => ({
  type: Constants.EDIT_PROPERTY_SCHEMA_SUCCESS,
  payload: { property }
});

export const editPropertySchemaFailed = (): EditPropertySchemaFailed => ({
  type: Constants.EDIT_PROPERTY_SCHEMA_FAILED
});
